module.exports = __webpack_public_path__ + "static/media/stratex_assess_logo_tag.9dc41c76.svg";